import script from "./memory-spec-statistics-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./memory-spec-statistics-chart.vue?vue&type=script&lang=ts&setup=true"

import "./memory-spec-statistics-chart.vue?vue&type=style&index=0&id=7b75addc&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b75addc"]])

export default __exports__